import { render, staticRenderFns } from "./NewsSelected.vue?vue&type=template&id=6d700f7e&scoped=true"
import script from "./NewsSelected.vue?vue&type=script&lang=js"
export * from "./NewsSelected.vue?vue&type=script&lang=js"
import style0 from "./NewsSelected.vue?vue&type=style&index=0&id=6d700f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d700f7e",
  null
  
)

export default component.exports
import {QCarousel,QCarouselSlide,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCarousel,QCarouselSlide,QImg,QCardSection})
